<script setup lang="ts">
    import { computed } from 'vue'
    import PkEditorRadioButtons from './PkEditorRadioButtons.vue'
    import { AgentType } from 'models'
    import { useI18n } from 'vue-i18n'

    const modelValue = defineModel<AgentType | string | undefined>({
        default: undefined,
    })

    const props = defineProps<{
        name: string
        readonly?: boolean
    }>()

    const { t } = useI18n()
    const { t: $t } = useI18n({
        useScope: 'global',
    })

    const options = computed(() => {
        const options = [
            {
                label: $t('agentType.chat'),
                value: AgentType.Chat,
            },
            {
                label: $t('agentType.reasoning'),
                value: AgentType.Reasoning,
            },
        ]
        if (props.readonly) {
            return options.filter((option) => option.value === modelValue.value)
        }
        return options
    })
</script>

<template>
    <PkEditorRadioButtons v-model="modelValue" :name :options :readonly>
        <template #chat>
            <div>
                <div class="flex items-center gap-4 mb-4">
                    <VvIcon name="ri:chat-1-line" class="w-16 h-16" />
                    <strong class="font-semibold">
                        {{ $t('agentType.chat') }}
                    </strong>
                </div>
                <p class="text-word-3 text-12">
                    {{ t('chatInfo') }}
                </p>
            </div>
        </template>
        <template #reasoning>
            <div>
                <div class="flex items-center gap-4 mb-4">
                    <VvIcon name="ri:lightbulb-line" class="w-16 h-16" />
                    <strong class="font-semibold">
                        {{ $t('agentType.reasoning') }}
                    </strong>
                </div>
                <p class="text-word-3 text-12">
                    {{ t('reasoningInfo') }}
                </p>
            </div>
        </template>
    </PkEditorRadioButtons>
</template>

<i18n lang="json">
{
    "en": {
        "chatInfo": "Agent with conversational interface, designed to interact directly with users through chat.",
        "reasoningInfo": "Agent without conversational interface, designed to perform complex reasoning tasks and decision-making processes."
    },
    "it": {
        "chatInfo": "Agente con interfaccia conversazionale, progettato per interagire direttamente con gli utenti tramite chat.",
        "reasoningInfo": "Agente per il ragionamento senza interfaccia conversazionale, progettato per eseguire compiti di ragionamento complessi e processi decisionali."
    }
}
</i18n>
